import PanierI18n from './Panier.i18n.js';
import {
    mapActions,
    mapGetters,
    mapMutations,
} from 'vuex';

export default {

    components: {},

    props: {},

    computed: {
        ...mapGetters([
            'cart', 'familleArticles', 'auth', 'creatingDevis', 'priceHiddenMode'
        ]),

        titre() {
            return this.$route.meta.titre;
        },

        Brut_HT() {
            let Brut_HT = 0.00;
            this.cart.forEach(element => {
                Brut_HT += this.getPT(element);
            });
            this.brut = parseFloat(Brut_HT);
            return this.brut;
        },

        TOTAL_HT() {
            return parseFloat(this.brut) + this.PORT_HT;
        },

        TTC() {
            return this.TOTAL_HT + this.TOTAL_HT * 0.2;
        },

        PORT_HT() {
            let PortHT = 0.00;
            const ind = this.cart.findIndex(element => {
                return ['PLA.', 'FLE.', 'ACCESSOIRE.'].includes(element.Famille)
            });
            //s'il n'y a pas que des inters et bronzes
            if (ind >= 0) {
                if (this.Brut_HT < 51) {
                    PortHT = 30
                } else if (this.Brut_HT >= 51 && this.Brut_HT < 101) {
                    PortHT = 35
                } else if (this.Brut_HT >= 101 && this.Brut_HT < 151) {
                    PortHT = 40
                } else if (this.Brut_HT >= 151 && this.Brut_HT < 201) {
                    PortHT = 45
                } else if (this.Brut_HT >= 201 && this.Brut_HT < 251) {
                    PortHT = 50
                } else if (this.Brut_HT >= 251 && this.Brut_HT < 301) {
                    PortHT = 55
                } else if (this.Brut_HT >= 301 && this.Brut_HT < 351) {
                    PortHT = 60
                } else if (this.Brut_HT >= 351 && this.Brut_HT < 401) {
                    PortHT = 65
                } else if (this.Brut_HT >= 401 && this.Brut_HT < 451) {
                    PortHT = 70
                } else if (this.Brut_HT >= 451 && this.Brut_HT < 501) {
                    PortHT = 75
                } else {
                    PortHT = 0 //Franco de port
                }

                // s'il n'y a que des inter et bronzes
            } else {
                //Calcul port sur total commande
                if (this.Brut_HT >= 1000) {
                    PortHT = 0
                } else {
                    PortHT = (this.Brut_HT * 0.15)
                }
            }

            return parseFloat(PortHT)
        },

        quantiteTotalInter() {
            let total = 0
            this.cartTrie['INTER.'].forEach(aInter => {
                total = total + aInter.Quantite
            })
            return total
        },

        prixTotalInter() {
            let total = 0
            this.cartTrie['INTER.'].forEach(aInter => {
                total = total + aInter.PU * aInter.Quantite
            })
            return total
        },

        cartTrie() {
            let cartTrieParFamille = {};
            // Ajout des articles famille par famille.
            this.cart.forEach(element => {
                if (cartTrieParFamille[element.Famille] == undefined) {
                    cartTrieParFamille[element.Famille] = [];
                }
                cartTrieParFamille[element.Famille].push(element);
            });

            // Positionnement des Inters en fin de
            let tempInter = null
            if (cartTrieParFamille['INTER.']) {
                tempInter = cartTrieParFamille['INTER.']
                delete cartTrieParFamille['INTER.']
                cartTrieParFamille['INTER.'] = tempInter
            }
            // Positionnement des Bronzes en fin de
            let tempBronze = null
            if (cartTrieParFamille['BRONZE.']) {
                tempBronze = cartTrieParFamille['BRONZE.']
                delete cartTrieParFamille['BRONZE.']
                cartTrieParFamille['BRONZE.'] = tempBronze
            }
            return cartTrieParFamille;
        }

    },

    data() {
        return {
            quantite: 0,
            brut: 0.00,
            tva: 0.00,
            screenWidth: 1200,
            isInterOpen: false,
            prevRoute: null,
            namePath: '',
            isPanierDisplayed: false,
            isPlaqueOpen: false,
            isFleursOpen: false,
            isAccesoiresOpen: false,
            isInterOpen: false,
            isBronzeOpen: false,
            commentaire: ''
        };
    },

    watch: {
        commentaire() {
            // Stockage du commentaire dans le local storage.
            localStorage.setItem('commentaire', this.commentaire)
        }
    },

    methods: {
        ...mapActions(['getFamilleArticles', 'createDevis']),
        ...mapMutations([
            'removeArticle',
            'ArticleQuantityP',
            'ArticleQuantityM',
            'ArticleQuantityS',
            'clearCart'
        ]),


        RemoveArticle(idCommande) {
            let index = this.cart.findIndex(element => element.idCommande == idCommande)
            this.removeArticle(index);
        },

        QuantitePlus(idCommande) {
            let index = this.cart.findIndex(element => element.idCommande == idCommande)
            this.ArticleQuantityP(index);
        },
        QuantiteMoins(idCommande) {
            let index = this.cart.findIndex(element => element.idCommande == idCommande)
            this.ArticleQuantityM(index);
        },

        /**
         * Fonction pour changer la quantité d'un produit.
         * @param {*} pCommande
         */
        changeQuantity(pCommande) {
            let index = this.cart.findIndex(element => element.idCommande == pCommande.idCommande)
            const infoQuantite = {
                index: index,
                quantity: parseInt(pCommande.Quantite)
            };
            this.ArticleQuantityS(infoQuantite);
            this.$forceUpdate()
        },

        /**
         * Fonction pour revenir à l'acceuil.
         */
        goToHome() {
            this.$router.push({
                path: '/'
            })
        },

        /**
         * Fonction pour afficher/cache la partie sur les inters.
         */
        toggleCollapseInter(pCodeFam) {
            if (this.getFamilleName(pCodeFam) === 'INTER') {
                this.isInterOpen = !this.isInterOpen;
            }
        },

        /**
         * Fonction pour récupérer le nom complet de la famille d'articles.
         * @param {*} CodeFam
         */
        getFamilleName(CodeFam) {
            let name = ''
            this.familleArticles.forEach(aFamille => {
                if (aFamille.Code === CodeFam) {
                    name = aFamille.Nom
                }
            })
            return name
        },

        getTotalQuantiteMemePLRef(pCommande) {
            let pPLRef = pCommande.PLRef
            let totalQuantite = 0
            this.cart.forEach(aArticle => {
                if (aArticle.PLRef && aArticle.PLRef === pPLRef && aArticle.Code !== pCommande.Code) {
                    totalQuantite = totalQuantite + aArticle.Quantite
                }
            })

            return totalQuantite
        },

        /**
         * Fonction pour obtenir le tarif unitaire en fonction de la quantité d'article.
         * Des tarifs dégressifs peuvent en effet être appliqués.
         * Si plusieurs articles possèdent le même PL_ref, alors ils sont regroupés pour l'application du tarif dégressif.
         * @param {*} pCommande
         */
        getPU(pCommande) {
            let prixUnitaire = 0
            // S'il existe des tarifs unitaire dégressifs.
            if (pCommande.Tarifs != undefined && pCommande.Tarifs.length > 0) {
                // Récupération de la quantité de tous les articles ayant le même PL ref.
                const totalProduitsMemePLRef = pCommande.Quantite + this.getTotalQuantiteMemePLRef(pCommande)
                prixUnitaire = parseFloat(pCommande.PrixBaseHT)
                pCommande.Tarifs.forEach(aTarif => {
                    // Si la quantité est inférieure à la borne, alors on récupère la valeur du tarif
                    // et on indique qu'il a été trouvé pour éviter de l'écraser.
                    if (totalProduitsMemePLRef <= parseFloat(aTarif.Borne)) {
                        prixUnitaire = parseFloat(aTarif.Valeur) + (pCommande.SocleChoose ? parseFloat(pCommande.socle_PU) : 0)
                    }
                })
            } else {
                prixUnitaire = pCommande.PU
            }
            return parseFloat(prixUnitaire.toFixed(2))
        },

        /**
         * Fonction pour calculer le total.
         * @param {*} pCommande
         * @returns
         */
        getPT(pCommande) {
            const prixUnitaire = this.getPU(pCommande)
            return prixUnitaire * pCommande.Quantite
        },

        /**
         * Fonction pour obtenir le chemin de l'article en fonction du de la famille.
         * @param {*} CodeFam
         * @returns
         */
        getArticlePath(CodeFam) {
            let subPath = ''
            if (CodeFam === 'PLA.') {
                subPath = 'plaques'
            } else if (CodeFam === 'FLE.') {
                subPath = 'fleurs'
            } else if (CodeFam === 'ACCESSOIRE.') {
                subPath = 'accessoires'
            } else if (CodeFam === 'BRONZE.') {
                subPath = 'bronze'
            } else if (CodeFam === 'INTER.') {
                subPath = 'inter'
            }
            return subPath
        },

        goBack() {
            if (this.prevRoute != null) {
                let fullPath = this.prevRoute.fullPath;
                let arrayFP = fullPath.split('/');
                let path = '/';
                if (arrayFP.length >= 2 && ['plaques', 'fleurs', 'accessoires', 'inter', 'bronze'].includes(arrayFP[1])) {
                    path = '/' + arrayFP[1]
                }
                this.$router.push(path);
            } else {
                this.$router.push('/');
            }
        },

        /**
         * Fonction pour formatter le code article et enlever l'éventuel "/" en le remplaçant par "&".
         * @param {*} pCode
         * @returns
         */
        formatCodeArticle(pCode) {
            if (pCode.includes('/')) {
                pCode = pCode.replace('/', '$')
            }
            return pCode
        },

        /**
         * Fonction pour modifier le code article utilisé pour l'image. Remplacement de "/" par "-".
         * @param {*} pCode
         * @returns
         */
        formatCodeArticleForImage(pCode) {
            if (pCode) {
                if (pCode.includes('/')) {
                    pCode = pCode.replace('/', '-')
                }
                return pCode
            }
        },

        controlerCGV() {
            this.$refs['modalCGV'].hide();
            this.order();
        },

        controleDevis() {
            if (this.cart.length == 1 && (this.cart[0].code == '1812R' || this.cart[0].code == '1812ER')) {
                this.notify('error', 'Erreur', "Les articles 1812R et 1812ER ne peuvent êtres expédiés seuls. Veuillez ajouter au moins un autre article.")
                return false;
            }
            return true;
        },

        /**
         * Fonction pour créer le devis.
         */
        order() {
            if (!this.controleDevis()) {
                return 0;
            };

            let lignesDevisFleurs = []
            let lignesDevisPlaques = []
            this.cart.forEach(aItem => {
                let options = ''
                if (aItem.Options != undefined && aItem.Options.startsWith(' -')) {
                    options = aItem.Options.substring(2)
                }
                let ligneDevis;
                if (aItem.Famille == 'INTER.') {
                  ligneDevis = {
                      CodeArticle: aItem.Code,
                      Quantite: aItem.Quantite*5,
                      Commentaire: aItem.Commentaire,
                      PLRef: aItem.PLRef,
                      Nom: aItem.Nom,
                      SocleChoose: aItem.SocleChoose,
                      Sup: aItem.sup,
                      Options: options
                  }
                } else {
                  ligneDevis = {
                      CodeArticle: aItem.Code,
                      Quantite: aItem.Quantite,
                      Commentaire: aItem.Commentaire,
                      PLRef: aItem.PLRef,
                      Nom: aItem.Nom,
                      SocleChoose: aItem.SocleChoose,
                      Sup: aItem.sup,
                      Options: options
                  }

                }
                if (aItem.Famille === 'FLE.') {
                    lignesDevisFleurs.push(ligneDevis)
                } else {
                    lignesDevisPlaques.push(ligneDevis)
                }

            })
            const devis = {
                CodeTiers: this.auth.Code,
                Commentaire: this.commentaire,
                LignesDevisFleurs: lignesDevisFleurs,
                LignesDevisPlaques: lignesDevisPlaques
            }
            this.createDevis(devis).then(res => {
                // Vidage du panier
                this.clearCart()
                this.$router.push('/confirmation')
            }).catch(err => {
                console.log(err)
                this.notify('error', 'Erreur', "Erreur lors de la création du devis. Veuillez réessayer plus tard.")
            })


        },

        toggleAccordeon(CodeFam) {
            if (CodeFam === 'PLA.') {
                this.isPlaqueOpen = !this.isPlaqueOpen
            } else if (CodeFam === 'FLE.') {
                this.isFleursOpen = !this.isFleursOpen
            } else if (CodeFam === 'ACCESSOIRE.') {
                this.isAccesoiresOpen = !this.isAccesoiresOpen
            } else if (CodeFam === 'BRONZE.') {
                this.isBronzeOpen = !this.isBronzeOpen
            } else if (CodeFam === 'INTER.') {
                this.isInterOpen = !this.isInterOpen
            }
        },
        isFamilleHidden(CodeFam) {
            if (CodeFam === 'PLA.') {
                return !this.isPlaqueOpen
            } else if (CodeFam === 'FLE.') {
                return !this.isFleursOpen
            } else if (CodeFam === 'ACCESSOIRE.') {
                return !this.isAccesoiresOpen
            } else if (CodeFam === 'BRONZE.') {
                return !this.isBronzeOpen
            } else if (CodeFam === 'INTER.') {
                return !this.isInterOpen
            }
        },

        heightSuperiorWidth(src) {
            let img = new Image();
            img.src = src;
            return img.height >= img.width
        }
    },

    filters: {
        formatNumber: (pValue) => {
            return parseFloat(pValue).toLocaleString('fr-FR', {
                style: "currency",
                currency: "EUR"
            })
        },
    },

    mounted() {
        window.addEventListener("resize", (e) => this.screenWidth = window.innerWidth);
        this.screenWidth = window.innerWidth;
        this.namePath = this.$route.path.substring(1);
        // Récupération du commentaire stocké dans le local storage
        if (localStorage.getItem('commentaire')) {
            this.commentaire = localStorage.getItem('commentaire')
        } else {
            this.commentaire = ''
        }
        // Récuperation des famille articles
        this.getFamilleArticles().then(res => {}).catch(err => {
            console.log(err)
        })

        // Si il n'y a que des INTER, alors ouverture de la section les contenant
        if (this.cartTrie['INTER.'] && Object.keys(this.cartTrie).length === 1) {
            this.isInterOpen = true
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from
        })
    },

    i18n: PanierI18n,

};
